module.exports = __webpack_public_path__ + "static/media/prd_vegi.80b2bed9.png";